module.exports = __webpack_public_path__ + "img/consulta-certidao.a2e5e803.png";